export default "__VITE_ASSET__Gy49XC$z__"